import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { PasswordResetPage } from "../components/index.js";
import { useApiClient } from "../api/ApiContext.jsx";
import AuthLayout from "../layout/AuthLayout.jsx";
import { InlineMessage, errorText } from "../ui/Feedback.jsx";

export default function PasswordResetScreen() {
  const api = useApiClient();
  const navigate = useNavigate();
  const [sent, setSent] = useState(false);
  const [email, setEmail] = useState("");
  const [error, setError] = useState(null);

  async function handleSubmit(value) {
    setError(null);
    setEmail(value);
    try {
      // 202 with no body detail — the UI must not reveal whether the account exists.
      await api.auth.requestPasswordReset(value);
      setSent(true);
    } catch (err) {
      setError(errorText(err, "Could not send the reset link."));
    }
  }

  return (
    <AuthLayout>
      {error ? <InlineMessage tone="danger">{error}</InlineMessage> : null}
      <PasswordResetPage
        sent={sent}
        onSubmit={handleSubmit}
        onBackToLogin={() => navigate("/login")}
      />
      {sent ? (
        <p style={{ textAlign: "center", fontSize: "var(--text-xs)", color: "var(--text-muted)", marginTop: 12 }}>
          Already have the link? Open it in this browser to set a new password.
        </p>
      ) : null}
    </AuthLayout>
  );
}
